import Request from 'redux/config/services/Request'
import { LaunchProgramsState } from './launchProgramsSlice'

export const getDraftProgramState = async (): Promise<any> => {
  return Request.get('/hr/profile/program_creation_state/latest/')
}

export const createDraftProgramState = async (
  state: LaunchProgramsState
): Promise<any> => {
  return Request.post('/hr/profile/program_creation_state/', state)
}

export const deleteDraftProgramState = async (): Promise<any> => {
  return Request.del(`/hr/profile/program_creation_state/delete-latest/`)
}
